/**
 * Remembers the Draft batch created earlier in THIS browser tab's wizard session so that Back -> Continue
 * (or a retry after a failed upload) reuses it instead of leaving an orphan Draft behind. Per tab
 * (sessionStorage), best effort only: storage can be unavailable, and a stale id simply falls back to
 * starting a new batch (the caller verifies the batch is still a Draft of the same source system).
 */
const KEY = 'epn.payrollHistoryImport.draftBatch';

export interface DraftBatch {
  id: string;
  sourceSystem: string;
  /** The provider picked on step 1. Absent in a draft written before providers existed. */
  provider?: string;
}

export function readDraftBatch(): DraftBatch | null {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<DraftBatch>;
    if (typeof parsed.id !== 'string' || typeof parsed.sourceSystem !== 'string') return null;
    return typeof parsed.provider === 'string'
      ? { id: parsed.id, sourceSystem: parsed.sourceSystem, provider: parsed.provider }
      : { id: parsed.id, sourceSystem: parsed.sourceSystem };
  } catch {
    return null;
  }
}

export function writeDraftBatch(draft: DraftBatch): void {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    /* storage unavailable: the worst case is one extra Draft */
  }
}

export function clearDraftBatch(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
